import React from "react";
import "../../App.css";
import PaymentStatementForm from "../PaymentStatementForm";

function PaymentStatementPage({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("payment_statement")) {
    return;
  }
  return (
    <div className="page-vehicle">
      <PaymentStatementForm sessionObject={sessionObject} />
    </div>
  );
}

export default PaymentStatementPage;
